import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import CreateIcon from '@material-ui/icons/Create'
import clsx from 'clsx'
import React from 'react'

const circularPencilStlyes = makeStyles({
    circularPencilWrapper: {
        position: 'relative',
    },
    circularPencilRoot: {
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: '#fff',
        },
        '&.MuiIconButton-root.Mui-disabled': {
            backgroundColor: '#fff',
            '&:hover': {
                backgroundColor: '#fff',
            },
        },
    },
    circularPencilButton: {
        border: '1px solid #13B5EA',
    },
})

export interface CircularPencilButtonProps {
    containerClassName?: string
    ariaLabel: string
    hide?: boolean
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const CircularPencilButton: React.FC<CircularPencilButtonProps> = ({
    containerClassName,
    ariaLabel,
    hide = false,
    onClick,
    ...other
}) => {
    const classes = circularPencilStlyes()
    return (
        <div
            className={containerClassName}
            style={{ display: hide ? 'none' : 'block' }}
            {...other}
        >
            <IconButton
                className={clsx('pencil-button', classes.circularPencilButton)}
                classes={{
                    root: classes.circularPencilRoot,
                }}
                aria-label={ariaLabel}
                color="default"
                size="small"
                onClick={onClick}
            >
                <CreateIcon />
            </IconButton>
        </div>
    )
}

export default CircularPencilButton
